// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as UtmConstants$PorterinFeature from "../../../shared/core/constants/UtmConstants.mjs";
import * as AnalyticsHelper$PorterinFeature from "../../../shared/core/helpers/AnalyticsHelper.mjs";
import * as QueryParamsConstructor$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/query-params/QueryParamsConstructor.mjs";
import * as EventsTrackerHelper$PorterinFeature from "../../../shared/core/helpers/EventsTrackerHelper.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../shared/core/helpers/PublishEventsHelper.mjs";

var app_download_link = Config$PorterinUtils.oms_url + "/app";

function device(isDesktop) {
  if (isDesktop) {
    return "desktop";
  } else {
    return "mob";
  }
}

function current_city(city) {
  return Belt_Option.getWithDefault(city, "");
}

var ga_download_app_card_tap = "fe_allocstatus_download_app_tap";

function feature_source(id, page, device) {
  return id + "_" + page + "_" + device;
}

function buildDownloadLink(params, param_value) {
  $$Array.iteri((function (index, param) {
          var param_value_status = Belt_Option.getWithDefault(Js_dict.get(params, param), "");
          if (param_value_status.length === 0) {
            params[param] = Caml_array.get(param_value, index);
            return ;
          }
          
        }), UtmConstants$PorterinFeature.download_utm_params_keys);
  return app_download_link + "?" + Belt_Option.getWithDefault(QueryParamsConstructor$Catalyst.create(params), "");
}

function buildFareEstimateDownloadLink(params, param_value) {
  $$Array.iteri((function (index, param) {
          var param_value_status = Belt_Option.getWithDefault(Js_dict.get(params, param), "");
          if (param_value_status.length === 0) {
            params[param] = Caml_array.get(param_value, index);
            return ;
          }
          
        }), UtmConstants$PorterinFeature.download_utm_params_keys);
  var updated_params = $$Array.map((function (utm_param) {
          return utm_param + "=" + Belt_Option.getWithDefault(Js_dict.get(params, utm_param), "");
        }), UtmConstants$PorterinFeature.download_utm_params_keys);
  return Belt_Array.reduce(updated_params, app_download_link + "?", (function (acc, str) {
                return acc + "&" + str;
              }));
}

function getAppDownloadLinkStickyTop(query_params, city, isDesktop, current_page_route) {
  var page = AnalyticsHelper$PorterinFeature.getPageName(current_page_route);
  var param_value = [
    "website_sticky_ssr",
    "sticky_top_organic",
    "sticky_top_organic_" + page,
    "website_sticky_top_organic_" + page,
    "",
    (
      isDesktop ? "desktop" : "mob"
    ) + "_" + Belt_Option.getWithDefault(city, ""),
    feature_source("sticky_top", page, isDesktop ? "desktop" : "mob"),
    feature_source("sticky_top", page, isDesktop ? "desktop" : "mob")
  ];
  return buildDownloadLink(query_params, param_value);
}

function getAppDownloadLinkStickyBottom(query_params, city, isDesktop, current_page_route) {
  var page = AnalyticsHelper$PorterinFeature.getPageName(current_page_route);
  var param_value = [
    "sticky",
    "sticky_bottom_organic",
    "sticky_bottom",
    page,
    "",
    (
      isDesktop ? "desktop" : "mob"
    ) + "_" + Belt_Option.getWithDefault(city, ""),
    feature_source("sticky_bottom", page, isDesktop ? "desktop" : "mob"),
    feature_source("sticky_bottom", page, isDesktop ? "desktop" : "mob")
  ];
  return buildFareEstimateDownloadLink(query_params, param_value);
}

function getAppDownloadLinkFareEstimate(query_params, city, isDesktop, current_page_route) {
  var page = AnalyticsHelper$PorterinFeature.getPageName(current_page_route);
  var param_value = [
    "fare_estimate",
    "fare_estimate_organic",
    "static_download",
    page,
    "",
    (
      isDesktop ? "desktop" : "mob"
    ) + "_" + Belt_Option.getWithDefault(city, ""),
    feature_source("fare_estimate", page, isDesktop ? "desktop" : "mob"),
    feature_source("fare_estimate", page, isDesktop ? "desktop" : "mob")
  ];
  return buildFareEstimateDownloadLink(query_params, param_value);
}

function getAppDownloadLinkSection(query_params, city, isDesktop, current_page_route) {
  var page = AnalyticsHelper$PorterinFeature.getPageName(current_page_route);
  var param_value = [
    "mid_page",
    "mid_page_organic",
    "static_download",
    page,
    "",
    (
      isDesktop ? "desktop" : "mob"
    ) + "_" + Belt_Option.getWithDefault(city, ""),
    feature_source("mid_page", page, isDesktop ? "desktop" : "mob"),
    feature_source("mid_page", page, isDesktop ? "desktop" : "mob")
  ];
  return buildDownloadLink(query_params, param_value);
}

function getAppDownloadLinkFooter(query_params, city, isDesktop, current_page_route) {
  var page = AnalyticsHelper$PorterinFeature.getPageName(current_page_route);
  var param_value = [
    "footer",
    "footer_organic",
    "static_download",
    page,
    "",
    (
      isDesktop ? "desktop" : "mob"
    ) + "_" + Belt_Option.getWithDefault(city, ""),
    feature_source("footer", page, isDesktop ? "desktop" : "mob"),
    feature_source("footer", page, isDesktop ? "desktop" : "mob")
  ];
  return buildDownloadLink(query_params, param_value);
}

function publishDownloadAppCardEvent(category, user) {
  PublishEventsHelper$PorterinFeature.publishEvents(category, ga_download_app_card_tap, undefined);
  EventsTrackerHelper$PorterinFeature.publishEventParameter(ga_download_app_card_tap, {
        fe_allocstatus_download_app_tap_parameter: Belt_Option.mapWithDefault(user, "", (function (us) {
                return Belt_Option.getWithDefault(us.mobile, "");
              }))
      });
}

export {
  app_download_link ,
  device ,
  current_city ,
  ga_download_app_card_tap ,
  feature_source ,
  buildDownloadLink ,
  buildFareEstimateDownloadLink ,
  getAppDownloadLinkStickyTop ,
  getAppDownloadLinkStickyBottom ,
  getAppDownloadLinkFareEstimate ,
  getAppDownloadLinkSection ,
  getAppDownloadLinkFooter ,
  publishDownloadAppCardEvent ,
}
/* Config-PorterinUtils Not a pure module */
